import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { LowerCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, output } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { ServiceType } from "../../../apis/networkdashboard/graphql/graphql";
import { ServiceSpeedPipe } from "../../../helpers/service-speed-pipe/service-speed-pipe";

@Component({
  selector: "port-visualiser",
  templateUrl: "port-visualiser.html",
  styleUrl: "port-visualiser.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule, LowerCasePipe, MatTooltipModule, ServiceSpeedPipe],
})
export class PortVisualiser {
  subscription = input.required<any>();
  available = input(true);
  highlightedSubscriptionId = input("");

  selected = output<ServiceType>();

  protected highlightedServiceSubscriptionId = linkedSignal(() => this.highlightedSubscriptionId());

  protected amountReserved = computed(() => this.subscription().amountReserved);
  protected bookingPercentage = computed(() => {
    const portSpeed = this.subscription().portSpeed;
    return portSpeed ? (this.amountReserved() * 100) / portSpeed : 0;
  });
  protected fullname = computed(() => this.subscription().customer.fullname);
  protected services = computed(() => this.subscription().services);

  clickBar(service: ServiceType): void {
    this.selected.emit(service);
    this.highlightedServiceSubscriptionId.set(service.subscriptionId);
  }
}
